module.exports = __webpack_public_path__ + "static/img/landing_light.bf15482.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_files/images/mergedom/landing_light.png
// module id = dm6t
// module chunks = 0